module.exports = __webpack_public_path__ + "img/publications-office.05152976.png";